import styled from 'styled-components';
import { Button as BentoButton, LinkButton } from '@prezi/bento';
import { blue500 } from '@prezi/common-design';
export const Button = styled(BentoButton).withConfig({
  displayName: "Buttons__Button",
  componentId: "ded3he-0"
})(["width:min-content;white-space:nowrap;min-width:114px;"]);
export const PrimaryButton = styled(Button).withConfig({
  displayName: "Buttons__PrimaryButton",
  componentId: "ded3he-1"
})(["color:", ";&:hover{color:", ";}svg{path{fill:", ";}}"], blue500, blue500, blue500);
export const TertiaryButton = styled(LinkButton).withConfig({
  displayName: "Buttons__TertiaryButton",
  componentId: "ded3he-2"
})(["width:min-content;white-space:nowrap;"]);